/* eslint-disable no-magic-numbers */
import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SafePipe } from '@shared/pipe.safe';
import { ContentPromo } from './content-promo-detail';

@Component({
  selector: 'app-content-promo-detail',
  standalone: true,
  imports: [NgClass, TranslatePipe, SafePipe],
  templateUrl: './content-promo-detail.component.html',
  styleUrl: './content-promo-detail.component.scss'
})
export class ContentPromoDetailComponent {
  data = input<ContentPromo>();
  buy = output<void>();

  currentHeight = 0;

  isShowDesc: boolean = false;
  isShowTerms: boolean = false;

  onClickAccordion(type: 'description' | 'terms') {
    if (type === 'description') this.isShowDesc = !this.isShowDesc;
    if (type === 'terms') this.isShowTerms = !this.isShowTerms;
  }

  onClickBuy() {
    this.buy.emit();
  }
}
